export const ACTIVATE_BUSINESS_INTRODUCTION = 'ACTIVATE_BUSINESS_INTRODUCTION';
export const SUBMIT_BUSINESS_INTRODUCTION = 'SUBMIT_BUSINESS_INTRODUCTION';
